import { spacing, spacingSizes } from '../../../theme';
import { grey } from '@mui/material/colors';

export type Theme = {
  palette: {
    text: string;
    textSubtle: string;
    divider: string;
    background: {
      default: string;
    };
    grey: {
      50: string;
      100: string;
      300: string;
      500: string;
      600: string;
      700: string;
      900: string;
    };
  };
  spacing: number;
  spacingSizes: {
    xxs: number;
    xs: number;
    sm: number;
    md: number;
    lg: number;
    xl: number;
    xxl: number;
    xxxl: number;
  };
};

const theme: Theme = {
  palette: {
    text: grey[900],
    textSubtle: grey[600],
    divider: grey[300],
    background: {
      default: '#FFFFFF',
    },
    grey: {
      50: grey[50],
      100: grey[100],
      300: grey[300],
      500: grey[500],
      600: grey[600],
      700: grey[700],
      900: grey[900],
    },
  },
  spacing,
  spacingSizes,
};

const opacity = (hex: string, alpha: number) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export default {
  ...theme,
  opacity,
  spacing: (...values: Array<number>) =>
    values.map((v) => `${v * theme.spacing}px`).join(' '),
};
